import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminLayout from './components/Layout/AdminLayout';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import States from './pages/States/States';
import Cities from './pages/Cities/Cities';
import Users from './pages/Users/Users';
import Subscriptions from './pages/Subscriptions/Subscriptions';
import CmsPages from './pages/CmsPages/CmsPages';
import HelpSupport from './pages/HelpSupport/HelpSupport';
import Notifications from './pages/Notifications/Notifications';
import ProtectedRoute from './routes/ProtectedRoute';

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="cms-pages" element={<CmsPages />} />
        <Route path="help-support" element={<HelpSupport />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="states" element={<States />} />
        <Route path="cities" element={<Cities />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default App;
